import React, { useState, useEffect, ReactNode } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import styles from './index.pcss';
import Text from '../../atoms/Text';
import Button from '../../atoms/button';
import Input from '../../molecules/Input';
import Dialog from '../../molecules/Dialog';
import { RootState } from '../../types/rootState';
import { setCookie } from '../../utils/cookie';
import { isLandingPage } from '../../../utils/common';
import { validatePincode } from '../../utils/regexUtils';
import { getCurrentStore } from '../../selectors/metaData';
import properties from '../../../modules/ajio-util/properties';
import { signInCheck } from '../../../components/common/CheckUserStatus';
import { readCookie, getCookie, createCookieForHours, eraseCookie } from '../../../components/common/Cookie';
import { showLoader, hideLoader } from '../../../actions/shared/loader';
import { fetchProducts } from '../../../actions/shared/productsData.js';
import { changeAddressSelectionOnCart } from '../../../cart/actions/cart';
import { postalCodeFetch, getAddressData } from '../../../myaccount/actions/addressBook';
import AddAddress from '../../../myaccount/components/mobile/AddAddress';
import "../../../static/scss/myaccount/common/addDeleteAddressPopup.scss";
import SelectAddressDialog from './AddressBarDialogs/SelectAddressDialog';
import {
  getLocaleData,
  updateBannerState,
  fetchPostalCodeDetails,
  userAllowedLocationForRuntimeLocale
} from '../../../actions/localeBannerApi/localeClientCall';
import { gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import deferAnalytics from '../../utils/deferAnalytics';
import { getPageNameForGA } from '../../../utils/pageInfo';
import { createCookie } from '../../../components/common/Cookie';
import { setAddress } from '../../../myaccount/actions/addressBook';
import {
  getPriorityDeliveryPhase2Flag,
  getRushDeliveryFlag,
  getEnableAdsOnSlp,
  getEnableAdsOnPlp,
  getTrendBasedDiscoveryFlag,
  getTrendBasedDiscoveryConfig
} from '../../../refresh/selectors/featureFlagsSelector';
import { updateUserAddress } from '../../../actions/shared/miscellaneous';
import { rushPDPDeliveryTypeAPICall, chechRushAvailability as chechRushAvailabilityAction } from '../../../actions/shared/ajioRush';

const GeoAddressMapWrapper = React.lazy(
  () => import('./AddressBarDialogs/GeoAddressMapWrapper')
);
import { getAmplitudeExperimentVariant, getAmplitudeVariantPayload } from '../../../utils/amplitudeCommon';
import { setSelectedBillingAddress } from '../../../cart/actions/gst';
import { setErrorObject } from '../../../actions/shared/HTTPError';
import { getDeliveryAddress } from '../../../refresh/selectors/cartSelector';

const cx = classNames.bind(styles);
const pincodeErrorLabel = 'Please enter a valid pincode';
const imageBaseUrl = properties.getProperty('imageBaseUrl');

const logoURL = `${imageBaseUrl}/static/img/user-address-mobile.png`;
const locationIconUrl = `${imageBaseUrl}/static/img/location_black.svg`;
const fleekLocationIconUrl = `${imageBaseUrl}/static/img/location_white.svg`;
const currentLocationURL = `${imageBaseUrl}/static/img/currentLocationIcon.svg`;
const currentLocationLuxeURL = `${imageBaseUrl}/static/img/currentLocationIconLuxe.svg`;
const locationDetectLogoURL = `${imageBaseUrl}/static/img/location-detect-logo.svg`;

function roundToSix(value = '') {
  if (value === '' || value === null || value === undefined) return '';

  const num = Number(value);
  if (!Number.isFinite(num)) return '';

  return Number(num.toFixed(6));
}

const AddressBarWrapper = (props: {
  request?: any;
  currentStore?: any;
  changeAddress?: any;
  onDeliveryAddressChange?: () => void;
  addressBook?: any;
  cartDeliveryAddress?: any;
  allowUserLocation?: any;
  parentPage?: string;
  updateBannerState?: any;
  fetchFecetsFromPincode?: any;
  fetchPostalCodeDetails?: any;
  getlocationFromPostalCode?: any;
  handleDisplayDeliveryFilters?: any;
  enablePriorityDeliveryPhase2?: any;
  PDBannerInfo?: any;
  setPDBannerInfo?: any;
  showAddressBarDialog?: any;
  setShowAddressBarDialog?: any;
  callback?: any;
  initialCallBack?: any;
  getAddressList?: any;
  getDefaultAddress?: any;
  clearFilterState?: any;
  clearSLAFacetSelection?: any;
  updateUserAddressAction?: any;
  enableRushDelivery?: boolean;
  selectedSizeCode?: string;
  userAddressState?: any;
  clickedFilterTabCode?: string;
  isPlpOnLandingEnabled?: boolean;
  isFilterTabsOnLandingEnabled?: boolean;
  plpOnLandingCuratedId?: string;
  product?:any;
  getChechRushDeliveryAvailability?:any;
  chechRushAvailability?:any;
  setOpenRushAddressbar?:any;
  openRushAddressbar?:any;
  isPLAEnabled: boolean,
  plaAdsEliminationDisabled: boolean,
  isPlpBannerOsmosEnabled: boolean,
  osmosPlpBannerSlotsOrder: any,
  enableAdsOnPlpFlag: boolean,
  enableAdsOnSlpFlag: boolean,
  isBilling?: boolean,
  setIsBillingAddressChange?:any,
  setSelectedBillingAddress?:any,
  setErrorObject?:any,
  gstBusinessName?: string,
  onGSTAddressFlowExit?: () => void,
  addressSelectTitle?: string,
  onGeoBack?: () => void,
}) => {
  const [locationState, setLocationState] = useState('');
  const [fetchedLocationData, setFetchedLocationData] = useState<any>({});
  const [showFetchingPincodeCard, setShowFetchingPincodeCard] = useState<boolean>(false);

  const [pincode, setPincode] = useState<string>('');
  const [pincodeVal, setPincodeVal] = useState<string>('');
  const [showPincodeCard, setPincodeCardVisibility] = useState<boolean>(false);
  const [showConfirmPincodeCard, setConfirmPincodeCardVisibility] = useState<boolean>(false);
  const [pincodeError, setPincodeError] = useState<boolean>(false);
  const [pincodeErrorMsg, setPincodeErrorMsg] = useState<string>('');
  const [selectedAddress, setSelectedAddress] = useState<any>({});
  const [showAddressList, setShowAddressList] = useState<boolean>(false);
  const [showAddAddress, setShowAddAddress] = useState<boolean>(false);
  const [addressListLoader, setAddressListLoader] = useState(false);
  const [addressSelected, setAddressSelected] = useState<boolean>(false);

  const {
    request = {},
    currentStore,
    changeAddress,
    onDeliveryAddressChange = () => {},
    addressBook,
    enablePriorityDeliveryPhase2 = false,
    allowUserLocation,
    parentPage = '',
    updateBannerState,
    fetchFecetsFromPincode,
    fetchPostalCodeDetails,
    handleDisplayDeliveryFilters,
    PDBannerInfo = {},
    setPDBannerInfo,
    showAddressBarDialog = false,
    setShowAddressBarDialog,
    callback = () => {},
    initialCallBack = () => {},
    getAddressList,
    getDefaultAddress,
    clearSLAFacetSelection,
    selectedSizeCode='',
    updateUserAddressAction,
    userAddressState={},
    enableRushDelivery=false,
    rushAddrValidationRequired=false,
    setRushAddrValidationRequired=()=>{},
    clickedFilterTabCode = '',
    plpOnLandingCuratedId = '',
    isPlpOnLandingEnabled = false,
    getChechRushDeliveryAvailability,
    chechRushAvailability,
    isFilterTabsOnLandingEnabled = false,
    product={},
    setOpenRushAddressbar=()=>{},
    openRushAddressbar=false,
    isPLAEnabled=false,
    plaAdsEliminationDisabled=false,
    isPlpBannerOsmosEnabled=false,
    osmosPlpBannerSlotsOrder=false,
    enableAdsOnPlpFlag=false,
    enableAdsOnSlpFlag=false,
    isBilling=false,
    setIsBillingAddressChange=()=>{},
    setSelectedBillingAddress,
    setErrorObject,
    gstBusinessName='',
    onGSTAddressFlowExit=()=>{},
    addressSelectTitle='',
    onGeoBack,
    trendBasedDiscoveryFlag = {},
    trendBasedDiscoveryConfig = {},
    cartDeliveryAddress = {}
  } = props;

  const fromPDP = parentPage === 'PDP';
  let isFromFilter = parentPage === 'filter';
  let isFromPLP = parentPage === 'PLP';
  const fromCart = parentPage === 'CART';
  const fromHomepage = parentPage === 'HOME';

  const perfExperiments2512 = true;

  let addressWidth = window.innerWidth - (isFromFilter ? 360 : 240);

  const luxe = currentStore === 'luxe';
  const fleek = currentStore === 'ajiogram';
  const { pageName = '' } = getPageNameForGA(window.location.pathname || '', luxe, fleek);

  const { addresses = [] } = addressBook;
  const { formattedAddress = '', addressPoc = '' } = selectedAddress;
  const {
    city = '',
    state = '',
    zone = '',
    postalCode: fetchedPincodeVal = ''
  } = fetchedLocationData;

  let { postalData = {} } = addressBook;
  let { invalidpostalcode = false } = postalData;

  let defaultAddress = false;

  const {addressId: addressIdInState="", pincode:pincodeInState ="" } = userAddressState;

  if (addresses.length) {
    defaultAddress = addresses.find((address: { defaultAddress: boolean }) => {
      return address.defaultAddress;
    });
  }

  const handleUpdateCookie = async (userAddressObj: any = {}) => {
    const { pincode = '', formattedAddress = '', addressPoc = '', location={} } = userAddressObj;
    const { isPDBannerClicked = false, bannerRedirectionUrl = '' } = PDBannerInfo;

    let pincodeGrp = '';
    let cityData = '';
    let stateData = '';
    let zoneData = '';

    createCookie('PC', pincode, 365);
    // updating the lat long here as it is needed for the product api call
     createCookie('USER_ADDR', JSON.stringify({ 
            ...userAddressObj,
            location: {
              lat: roundToSix(location?.lat),
              long: roundToSix(location?.long),
            }
          }),365);

      createCookieForHours('RushLocationCoords', JSON.stringify({ lat:roundToSix(location?.lat), long:roundToSix(location?.long) }), 24);

    if (pincode) {
      await fetchPostalCodeDetails(pincode, async (response: any) => {
        pincodeGrp = response?.pincodeGroup || '';
        cityData = response?.city || '';
        stateData = response?.state || '';
        zoneData = response?.zone || '';

        createCookie('ZN', zoneData, 365);
        createCookie('ST', stateData, 365);
        createCookie('CT', cityData, 365);
        createCookie('PG', pincodeGrp, 365);

        createCookie('USER_ADDR', JSON.stringify({
            ...userAddressObj,
            pincodeGrp,
            location: {
              lat: roundToSix(location?.lat),
              long: roundToSix(location?.long),
            }
          }),365);
        updateUserAddressAction({ ...userAddressObj, pincodeGrp });

        if (fromHomepage && enableRushDelivery && location?.lat && location?.long) {
          eraseCookie('RushAvail');
          await chechRushAvailability(pincode, location);
        }

        fromHomepage && updateBannerState(response);
      });
    } else {
      createCookie('USER_ADDR', JSON.stringify({
              ...userAddressObj,            
              location: {
                lat: roundToSix(location?.lat),
                long: roundToSix(location?.long),
              } }), 365);
      updateUserAddressAction(userAddressObj);
    }
    const shouldDisplayFilters = !!(pincode || formattedAddress || addressPoc);
    if (isFromFilter || isFromPLP) {
      if (handleDisplayDeliveryFilters) {
        handleDisplayDeliveryFilters?.(shouldDisplayFilters);
      } else if (shouldDisplayFilters) {
        let pathname = `${request.pathname}`;
        const isFilterTabClickedOnLanding =
          isFilterTabsOnLandingEnabled && clickedFilterTabCode && isLandingPage();
        if (isPlpOnLandingEnabled && plpOnLandingCuratedId && isFilterTabClickedOnLanding) {
          pathname = `/api/curated/${plpOnLandingCuratedId}`;
        }
        // Reset to page 0 when pincode changes
        const updatedRequest = {
          ...request,
          pathname,
          query: {
            ...request.query,
            currentPage: 0
          }
        };
        const userState = (readCookie('LS') === 'LOGGED_IN') ? 'LOGGED_IN' : 'NON_LOGGED_IN';
        const customerType = readCookie('customerType');
        const CICookie = readCookie('CI');
        const segment_device_id = readCookie('segment_device_id');

        fetchFecetsFromPincode({
          request: JSON.parse(JSON.stringify(updatedRequest)),
          isRequestFromPlpOnLanding: isPlpOnLandingEnabled && isFilterTabClickedOnLanding,
          isPLAEnabled,
          plaAdsEliminationDisabledFlag: plaAdsEliminationDisabled,
          plpBannerAdsEnabled: isPlpBannerOsmosEnabled,
          customerUID: CICookie || '',
          segmentAnonymousId: segment_device_id,
          osmosPlpBannerSlotsOrder,
          zone: zoneData,
          state: stateData, 
          city: cityData, 
          userRestriction: customerType,
          userState,
          enableAdsOnPlpFlag,
          enableAdsOnSlpFlag,
          isTrendBasedDiscoveryFlag: trendBasedDiscoveryConfig?.master,
          trendBasedDiscoveryFlag: trendBasedDiscoveryConfig
        });
      }
    }
    if (isPDBannerClicked) {
      window.location.href = bannerRedirectionUrl;
    }
    if (isFromFilter) {
      clearSLAFacetSelection?.();
    }
    if (fromPDP) {
      callback?.(pincode); //this is to call checkdelivery API for PDP.
    }
  };

  useEffect(() => {
    if (showAddressList || showAddressBarDialog) {
      gtmEventPush({
        event: 'pageload',
        page_name: 'Enable location screen'
      });
    }
  }, [showAddressList, showAddressBarDialog]);

  useEffect(() => { 
    const userCurrentAddress = readCookie('USER_ADDR');
    // on the cart, prefer the cart's delivery address; if that's empty fall back to the
    // saved USER_ADDR cookie, then the default address-book entry (unchanged elsewhere)
    const cartAddr =
      fromCart && cartDeliveryAddress && Object.keys(cartDeliveryAddress).length > 0
        ? cartDeliveryAddress
        : null;
    const userCurrentAddressObj =
      cartAddr ||
      (userCurrentAddress && JSON.parse(userCurrentAddress)) ||
      addressBook?.addresses?.filter(item => item?.defaultAddress)?.[0] ||
      {};
    // cart address uses postalCode; the cookie uses pincode — accept either
    const pincode = userCurrentAddressObj?.pincode || userCurrentAddressObj?.postalCode || '';
    const { formattedAddress = '', addressPoc = '', location = {} } = userCurrentAddressObj;
    pincode && setPincode(pincode);
    const url = window.location.href;
    const urlObj = new URL(url);
    let isPDBanner = enableRushDelivery && urlObj.searchParams.get('isPDBanner');
    let pincodeFromUrl = urlObj.searchParams.get('pincode') || '';
    setSelectedAddress({ formattedAddress, addressPoc });
    if(pincode && !formattedAddress && isPDBanner && pincodeFromUrl){
      setSelectedAddress({ formattedAddress:pincodeFromUrl, addressPoc });
      if(userCurrentAddress){
        createCookie('USER_ADDR', JSON.stringify({ ...userCurrentAddressObj, 
          pincode: pincodeFromUrl,
          formattedAddress:pincodeFromUrl, 
          location: {
                lat: roundToSix(location?.lat),
                long: roundToSix(location?.long),
              }  
          }), 365);
      }
      else{
        createCookie('USER_ADDR', JSON.stringify({ addressId:'', formattedAddress:pincodeFromUrl, addressPoc:'', location:'',pincode: pincodeFromUrl }), 365);
      }
    }

  }, [addressIdInState, pincodeInState, cartDeliveryAddress]);

  const fetchAddressList = (payload = {}) => {
    const { addressUpdate = true } = payload;
    const userEmailID = readCookie('U');

    const fetchAddrListCallback = (addressData: { addresses: any[] }) => {
      setAddressListLoader(false);
      const { addresses = [] } = addressData;
      if (addresses.length) {
        setAddress(addressData);
        // const defaultAddress = addresses.find((address: { defaultAddress: any }) => {
        //     return address.defaultAddress;
        //   });
        //   addressUpdate && handleAddressUpdate(defaultAddress);   
      }
    };

    const fetchDefaultAddrCallback = (responseData: any) => {
      setAddressListLoader(false);
      const defaultAddress = responseData?.defaultAddress?.addresses?.[0];
      addressUpdate && defaultAddress && handleAddressUpdate(defaultAddress);
    }

    setAddressListLoader(true);
    addressUpdate && getDefaultAddress(userEmailID, fetchDefaultAddrCallback, true);
    getAddressList({ isRequestOrginIsBrowser: true }, fetchAddrListCallback);
  };

  useEffect(() => {
    const isUserLoggedIn = signInCheck();
    const cartAddr =
      fromCart && cartDeliveryAddress && Object.keys(cartDeliveryAddress).length > 0
        ? cartDeliveryAddress
        : null;
    const userCurrentAddress = readCookie('USER_ADDR');
    const userCurrentAddressObj = cartAddr || (userCurrentAddress && JSON.parse(userCurrentAddress)) || {};
    const pincode = userCurrentAddressObj?.pincode || userCurrentAddressObj?.postalCode || '';
    const { formattedAddress = '', addressPoc = '' } = userCurrentAddressObj;

    if (pincode || formattedAddress) {
      pincode && setPincode(pincode);
      formattedAddress && setSelectedAddress({ formattedAddress, addressPoc });
    } else if (isUserLoggedIn) {
      fetchAddressList();
      // we want to fetch the address, as addreess 
  
    }

    gtmEventPush({
      event: 'address_loaded',
      event_category: 'address interaction',
      event_action: 'address loaded',
      event_label: pageName, //pass screen name
      default_address: !!defaultAddress
    });

    // Segment Push Event
    segmentEventPush({
      event: 'Address Bar Viewed',
      event_category: 'address interaction',
      event_action: 'address loaded',
      event_label: pageName // pass screen name
      // default_address: !!defaultAddress
    });

    if (isUserLoggedIn) {
      fetchAddressList({addressUpdate: false});
    }

    const url = window.location.href;
    const urlObj = new URL(url);
    let isPDBanner = enableRushDelivery && urlObj.searchParams.get('isPDBanner');
    let pincodeFromUrl = urlObj.searchParams.get('pincode') || '';

    // TODO:- check if any flags required in condition
    if (isFromPLP && isPDBanner === 'true') {
      if (!pincode && !formattedAddress) {
        if (pincodeFromUrl) {
          // check if pincodeFromUrl is valid
          // save the pincode in cookie and update it in the address bar
          // call fetchProducts API with pincode -> display products based on pincode 

          // TODO:- why setPincodeVal is not working ??
          // setPincodeVal(pincodeFromUrl);
          handleCheckPincode('pincodeFromUrl', pincodeFromUrl);
          setSelectedAddress({ formattedAddress:pincodeFromUrl, addressPoc:'' });
        } else {
          // open the dialog to enter pincode
          // if user gives location -> call fetchProducts API with pincode -> display relevant products
          // TODO:- display ZSR or PLP with current products ??
          
          addressAndBannerClickHandler('enter location');

          // setPincodeCardVisibility(true);
          // setPincodeError(false);
          // setPincodeErrorMsg('');
        }
      }
    }
  }, []);

  const defaultObject = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
  };

  const checkEnableLocationOrNot = () => {                  //->function to get location using navigator object wrt permissions
    // First check the geolocation permission status using navigator.permissions.query
    navigator.permissions
      ?.query({ name: 'geolocation' })
      .then(permissionStatus => {
        // If permission is granted, directly fetch location
        if (permissionStatus.state === 'granted') {
          setLocationState('granted'); // If already granted, set the state to 'granted'
          fetchLocation(); // Call the function to fetch the location
        } else if (permissionStatus.state === 'prompt') {
          setLocationState('prompt'); // If permission is still in 'prompt', prompt user
          fetchLocation();
        } else if (permissionStatus.state === 'denied') {
          setLocationState('denied'); // If permission is denied, show denied state
        }
      })
      .catch(error => {
        console.error('Error querying geolocation permission:', error);
        setLocationState('denied'); // Handle errors gracefully
      });
  
    // Fetch location function
    const fetchLocation = () => {
      // Timeout handler to detect if geolocation is taking too long
      const geolocationTimeout = setTimeout(() => {
        setLocationState('denied'); // Set state to 'denied' after timeout
      }, 5000);
  
      // Check geolocation support
      if (!navigator.geolocation) {
        setLocationState('denied'); // If geolocation is not supported
      } else {
        // Get current position
        navigator.geolocation.getCurrentPosition(
          (GeolocationPosition) => {
            // Clear the timeout once geolocation is retrieved
            clearTimeout(geolocationTimeout);
            const { coords: { latitude = '', longitude = '' } = {} } = GeolocationPosition;
  
            console.log('Location fetched:', latitude, longitude);
  
            setLocationState('granted'); // Update state to 'granted' after successful location fetch
          },
          (error) => {
            // Clear the timeout if there's an error
            clearTimeout(geolocationTimeout);
  
            // Handle different errors
            if (error.code === error.PERMISSION_DENIED) {
              setLocationState('denied'); // If permission was denied
            } else if (error.code === error.POSITION_UNAVAILABLE) {
              setLocationState('unavailable'); // If position is unavailable
            } else {
              setLocationState('prompt'); // If other errors occur
            }
          },
          defaultObject
        );
      }
    };
  };

  const enableDeviceLocation = () => {
    gtmEventPush({
      event: 'buttonTap',
      event_category: 'buttonTap',
      event_action: 'enable location',
      page_name: 'Enable location screen'
    });

  

    if (/Android/i.test(navigator.userAgent)) {
      window.location.href = 'intent:#Intent;action=android.settings.LOCATION_SOURCE_SETTINGS;end';
    }

    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      alert('Go to Settings > Privacy > Location Services to enable location.');
    }
  };

  const handleAddressUpdate = (addressObj: any) => {
    if (addressObj && Object.keys(addressObj).length) {
      let {
        postalCode: cityPincode = '',
        formattedAddress: formattedAdd = '',
        addressPoc: addressPocName = '',
        id: addressId = '',
        firstName = '',
        lastName = '',
        line1 = '',
        line2 = '',
        location = enableRushDelivery && ((addressObj?.latitude && addressObj?.longitude)) ? 
        { lat: addressObj?.latitude, long: addressObj?.longitude } : 
        {}
      } = addressObj;
      let newformattedAdd = formattedAdd || `${line1}, ${line2}, ${cityPincode}`;
      let newAddressPocName = addressPocName || `${firstName} ${lastName}`;
      setPincode(cityPincode);
      setSelectedAddress({ formattedAddress: newformattedAdd, addressPoc: newAddressPocName });
      setAddressSelected(true);
      if(!isBilling){
        handleUpdateCookie({ addressId, pincode: cityPincode, formattedAddress: newformattedAdd, addressPoc: newAddressPocName, location });
      }
      if(fromCart && !signInCheck()) {
        handleAddressChange({ pincode: cityPincode, lat: roundToSix(location?.lat), long: roundToSix(location?.long), enableRushDelivery });
      }

      if(enableRushDelivery && fromPDP && product?.productDetails?.code){
        let customerUuid = readCookie('CI');
        let latlong = readCookie('RushLocationCoords');
        fromPDP && getChechRushDeliveryAvailability(cityPincode, addressObj?.location || latlong, product?.productDetails?.code, customerUuid, false);
      }
    }
  };

  const handleAddressChange = (payload: any) => {
    if (isBilling) {
      setIsBillingAddressChange(false);
      const matchAddress = addressBook?.addresses?.find(item => item.id === payload.addressId);
      if (matchAddress) {
        setSelectedBillingAddress(matchAddress);
        const messageBar = {
          errorType: 'info',
          message: 'Address has been Updated'
        };
        setErrorObject(messageBar);
        let timeout = setTimeout(() => {
          setErrorObject({});
          clearTimeout(timeout);
        }, 5000);
      }
      return;
    }
    // notify the parent that the delivery address changed (e.g. cart resets the
    // "GST just applied" success so the gstInfoMessage note is shown for the new address)
    onDeliveryAddressChange();
    return changeAddress({ ...payload, skipFetchCart: fromCart ? false : true });
  };

  const handleConfirmPincode = (flag: string = '', pincodeFromUrl: string = '') => {
    // TODO:- to use pincodeFromUrl from pincodeVal only
    const isUserLoggedIn = signInCheck();
   const pincode =
      flag === 'confirmPincodeFlow'
        ? fetchedPincodeVal
        : flag === 'checkPincodeFlow'
        ? pincodeVal
        : pincodeFromUrl;
    if(fromCart || isUserLoggedIn) {
      handleAddressChange({ pincode: pincode });
    }
    handleUpdateCookie({ addressId: '', pincode: pincode, formattedAddress: '', addressPoc: '' });
    setPincodeVal('');
    setPincode(pincode);
    setPincodeError(false);
    setPincodeErrorMsg('');
    setPincodeCardVisibility(false);
    setConfirmPincodeCardVisibility(false);
    setSelectedAddress({});
    setAddressSelected(false);
  };

  const handleCheckPincode = (pincodeType: string, pincodeValue: string) => {
    const validatePincodeCallback = (response: any) => {
      const { invalidpostalcode = false, error = null } = response;
      if (!invalidpostalcode && !error) {
         handleConfirmPincode(
          pincodeType === 'pincodeFromInput' ? 'checkPincodeFlow' : 'pincodeFromUrlFlow',
          pincodeValue
        );
      } else {
        setPincodeError(true);
        if (error) {
          setPincodeErrorMsg(error?.message || 'Oops! something went wrong');
        }
      }
    };
    if (validatePincode(pincodeValue)) {
      props.getlocationFromPostalCode(
        { postalCode: pincodeValue },
        (response: any) => validatePincodeCallback(response),
        true
      );
    } else {
      setPincodeError(true);
      return;
    }
  };

  const addressAndBannerClickHandler = (action: string = '') => {         //->main function to trigger dialog/bottomsheet
    if(!selectedSizeCode && fromPDP) {
      return;
    }
    checkEnableLocationOrNot();
    
    requestAnimationFrame(() => {
      setShowAddressList(true);
    });

    setPDBannerInfo?.({
      isPDBannerClicked: false,
      bannerRedirectionUrl: ''
    });

    const pushAnalytics = () => {
      gtmEventPush({
        event: action ? 'check_address' : 'change_address',
        event_category: 'address interaction',
        event_action: action ? action : 'change address',
        event_label: pageName,
        default_address: !!defaultAddress
      });
    };

    deferAnalytics(pushAnalytics);
  };

  const suffixButton = (
    luxe: boolean | undefined,
    label: string,
    pincodeCheckFun: () => void
  ): ReactNode => (
    <div className={cx('check-button')}>
      <Button
        customClass={luxe ? 'underline-link-lightblack' : ''}
        id="pincode_check"
        htmlType="button"
        variant="text"
        size="sm"
        btnLabel={label}
        onClick={() => (fromPDP ? initialCallBack(pincodeCheckFun()) : pincodeCheckFun())}
        ariaLabel="check"
        emphasis={!!luxe}
      />
    </div>
  );

  const followText = (
    luxe: boolean | undefined,
    error: boolean,
    errorLabel: string | undefined,
    id:string|undefined
  ): ReactNode => {
    // if (!error) {
    //   return null;
    // }
    return (
      <div>
        <span style={{
          height:!error ? 0 : '',
          opacity:!error ? 0 : '',
        }} id={id || ''} className={luxe ? cx('luxe-error-text-color') : cx('pincode-error-text-color')} aria-live='assertive' aria-atomic='true'>
          { error ? errorLabel : ''}
        </span>
      </div>
    );
  };

  if (enableRushDelivery) {
    return (
      <React.Suspense fallback={<div style={{ minHeight: '56px' }} />}>
        <GeoAddressMapWrapper
          fromPDP={fromPDP}
          isFromFilter={isFromFilter}
          isFromPLP={isFromPLP}
          fromCart={fromCart}
          fromHomepage={fromHomepage}
          luxe={luxe}
          fleek={fleek}
          addressWidth={addressWidth}
          formattedAddress={formattedAddress}
          pincode={pincode}
          initialCallBack={initialCallBack}
          addressAndBannerClickHandler={addressAndBannerClickHandler}
          addressPoc={addressPoc}
          showFetchingPincodeCard={showFetchingPincodeCard}
          setShowFetchingPincodeCard={setShowFetchingPincodeCard}
          showConfirmPincodeCard={showConfirmPincodeCard}
          fetchedLocationData={fetchedLocationData}
          pincodeVal={pincodeVal}
          setPincodeVal={setPincodeVal}
          showPincodeCard={showPincodeCard}
          handleConfirmPincode={handleConfirmPincode}
          pincodeError={pincodeError}
          setPincodeError={setPincodeError}
          followText={followText}
          pincodeErrorMsg={pincodeErrorMsg}
          suffixButton={suffixButton}
          handleCheckPincode={handleCheckPincode}
          showAddressList={showAddressList}
          setShowAddressList={setShowAddressList}
          showAddAddress={showAddAddress}
          showAddressBarDialog={showAddressBarDialog}
          addresses={addresses}
          handleAddressChange={handleAddressChange}
          addressSelected={addressSelected}
          setPincodeCardVisibility={setPincodeCardVisibility}
          setConfirmPincodeCardVisibility={setConfirmPincodeCardVisibility}
          setPincodeErrorMsg={setPincodeErrorMsg}
          locationState={locationState}
          setFetchedLocationData={setFetchedLocationData}
          setAddressSelected={setAddressSelected}
          handleAddressUpdate={handleAddressUpdate}
          enableDeviceLocation={enableDeviceLocation}
          setShowAddressBarDialog={setShowAddressBarDialog}
          setShowAddAddress={setShowAddAddress}
          rushAddrValidationRequired={rushAddrValidationRequired}
          setRushAddrValidationRequired={setRushAddrValidationRequired}
          setOpenRushAddressbar={setOpenRushAddressbar}
          openRushAddressbar={openRushAddressbar}
          parentPage={parentPage}
          isBilling={isBilling}
          setIsBillingAddressChange={setIsBillingAddressChange}
          gstBusinessName={gstBusinessName}
      onGSTAddressFlowExit={onGSTAddressFlowExit}
          addressSelectTitle={addressSelectTitle}
          onGeoBack={onGeoBack}
    />
      </React.Suspense>
    );
  }

  return (
    <div
      className={cx(luxe ? 'luxeContainer' : fleek ? '' : 'container', {
        'container-pdp-css': fromPDP
      })}
    >
      <div
        className={cx(
          luxe ? 'luxe-address-main-div' : fleek ? 'fleek-address-main-div' : 'address-main-div',
          { 'luxe-filter-address-main-div': isFromFilter && luxe },
          { 'filter-address-main-div': isFromFilter },
          { 'fleek-plp-address-main-div': (isFromPLP || isFromFilter) && fleek },
          { 'pdp-main-div': fromPDP },
          { 'bg-luxe-pdp': fromPDP && luxe },
          { 'fleek-pdp-container': fleek && fromPDP }
        )}
        style={!pincode && !formattedAddress ? { padding: '12px' } : {}}
      >
        {parentPage === 'PDP' && (pincode || formattedAddress) && (
          <div
            className={cx('location-text', luxe && 'to-uppercase')}
            style={fleek ? { color: '#CDCECF' } : {}}
          >
            Location
          </div>
        )}

        {/* ENTER YOUR LOCATION */}
        {!pincode && !formattedAddress ? (
          <div
            className={cx('address-main-sec')}
            onClick={() =>
              fromPDP
                ? initialCallBack(addressAndBannerClickHandler('enter location'))
                : addressAndBannerClickHandler('enter location')
            }
            role="button"
            tabIndex={0}
            aria-label={
              fromPDP
                ? 'No location selected. Tap to enter location.'
                : 'No location found. Tap to enter your location.'
            }
          >
            {!fromPDP && (
              <img
                src={fleek ? fleekLocationIconUrl : locationIconUrl}
                alt=""
                className={cx('location-img', { 'filter-location-img': isFromFilter })}
              />
            )}
            {!fromPDP ? (
              <p className={cx('no-location-text', { 'fleek-no-location-text': fleek })}>
                No location found
              </p>
            ) : (
              <p className={cx('no-location-text-pdp')}>No location</p>
            )}
            <p
              className={cx(
                'enter-location-text',
                { 'luxe-enter-location-text': luxe },
                { 'fleek-enter-location-text': fleek }
              )}
            >
              Enter {!isFromFilter && 'your'} location
            </p>
          </div>
        ) : (
          <div
            className={cx('address-main-sec')}
            onClick={() =>
              fromPDP
                ? initialCallBack(addressAndBannerClickHandler(''))
                : addressAndBannerClickHandler('')
            }
          >
            {!fromPDP && (
              <img
                src={fleek ? fleekLocationIconUrl : locationIconUrl}
                alt=""
                className={cx('location-img', { 'filter-location-img': isFromFilter })}
              />
            )}

            {/* PIN CODE AVAILABLE */}
            {pincode && !formattedAddress && (
              <p className={cx('pincode-text-sec', { 'fleek-pincode-text-sec': fleek })}>
                <span className={cx('pincode-text-bold')}>Pincode </span>&nbsp; | {pincode}
              </p>
            )}
            {/* DEFAULT/SELECTED ADDRESS AVAILABLE */}
            {formattedAddress?.length > 0 && (
              <div className={cx('address-text-sec', { 'fleek-address-text-sec': fleek })} role='button' tabIndex={0} aria-haspopup='dialog' aria-label={`Address - ${addressPoc}, ${formattedAddress.slice(0, -6) || ''}, ${formattedAddress.slice(-6)}`}>
                <span
                  className={cx('address-text-bold', { 'filter-address-text-bold': isFromFilter })} aria-hidden="true"
                >
                  {addressPoc}
                </span>
                <div
                  className={cx('address-text-elipsis')}
                  style={{ maxWidth: `${addressWidth}px` }}
                  aria-hidden="true"
                >
                  &nbsp;| {formattedAddress.slice(0, -6)}
                </div>
                <span aria-hidden="true" role="text" aria-label={formattedAddress.slice(-6)?.toString().split('').map((d: string) => d === '0' ? 'zero' : d).join(' ')}>
                  <span aria-hidden="true">&nbsp;{formattedAddress.slice(-6)}</span>
                  </span>
              </div>
            )}
            <span
              className={cx(
                'address-change-text',
                { 'luxe-address-change-text': luxe },
                { 'fleek-enter-location-text': fleek }
              )}
              style={fromPDP ? { marginTop: '-12px' } : {}}
              role="button"
              tabIndex={0}
              aria-label="Change Delivery Address"
            >
              Change
            </span>
          </div>
        )}
      </div>

      <Dialog
        showDialog={showFetchingPincodeCard}
        type="drawer"
        onCancel={() => {
          setShowFetchingPincodeCard(false);
        }}
        customClass={luxe ? 'luxe-dialog' : undefined}
        ariaLabel="Fetching Location"
      >
        <div className={cx('pincode-container')}>
          <img src={locationDetectLogoURL} />
          <span style={{}} className={cx('pincode-container-text')}>
            Fetching your location...
          </span>
        </div>
      </Dialog>
      <Dialog
        showDialog={showConfirmPincodeCard}
        type="drawer"
        onCancel={() => {
          setConfirmPincodeCardVisibility(false);
        }}
        customClass={luxe ? 'luxe-dialog' : undefined}
        ariaLabel="Confirm Pincode"
      >
        <div className={cx('confirm-pincode-container')}>
          <div className={cx('confirm-pincode-sub-container')}>
            <img src={locationIconUrl} />
            <div className={cx('confirm-pincode-sub-container-div')}>
              <span className={cx('fetched-pincode-text')}>{fetchedPincodeVal}</span>
              <span className={cx('fetched-pincode-add')}>{`${city} (${zone}), ${state}`}</span>
            </div>
          </div>
          <div className={cx('confirm-pincode-btn-container')}>
            <Button
              onClick={() => {
                setConfirmPincodeCardVisibility(false);
                setPincodeCardVisibility(true);
                setPincodeError(false);
                setPincodeErrorMsg('');
                setPincodeVal(fetchedPincodeVal);
              }}
              ariaLabel="Edit"
              variant="secondary"
              btnLabel="Edit"
              customClass={cx('edit-pincode-btn', { 'luxe-btn': luxe })}
            />
            <Button
              ariaLabel="Confirm Pincode"
              variant="primary"
              fullWidth
              btnLabel="Confirm Pincode"
              customClass={luxe ? cx('luxe-btn') : ''}
              emphasis={!!luxe}
              onClick={() => handleConfirmPincode('confirmPincodeFlow')}
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        showDialog={showPincodeCard}
        type="drawer"
        onCancel={() => {
          setPincodeCardVisibility(false);
          setPincodeError(false);
          setPincodeErrorMsg('');
          setPincodeVal('');
        }}
        customClass={luxe ? 'luxe-dialog' : undefined}
        ariaLabel="Enter Pincode"
      >
        <div className={cx('dialog-container', 'enter-pin-code')}>
          <Text
            variant="T4"
            color={luxe ? 'Light_Black' : 'Nero'}
            weight="bold"
            textTransform={luxe ? 'is-uppercase' : 'none'}
            role='heading'
            ariaLevel={3}
          >
            Enter Pincode
          </Text>
          <div className={luxe ? cx('luxe-pincode-input') : cx('pincode-input')}>
            <Input
              id={'pincode-input'}
              name="pincode"
              maxLength={6}
              htmlType="text"
              label="Enter Pincode"
              autoComplete="off"
              defaultValue={pincodeVal}
              onChange={value => {
                setPincodeVal(value);
              }}
              validationError={pincodeError}
              followText={followText(
                luxe,
                pincodeError,
                pincodeErrorMsg ? pincodeErrorMsg : pincodeErrorLabel,
                'pincode-input-error'
              )}
              suffix={suffixButton(luxe, 'Check', () => {
                segmentEventPush({
                    event:'Pincode Entered',
                    cta_name: 'Check',                    
                    pincode: pincodeVal,                    
                    screen_name: 'Address Bar'
                  });
                handleCheckPincode('pincodeFromInput', pincodeVal)
              })}
              luxe={luxe}
              labelHidden={true}
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        showDialog={showAddressList || showAddressBarDialog}
        type="drawer"
        onCancel={() => {
          setShowAddressList(false);
          setShowAddressBarDialog?.(false);
        }}
        customClass={luxe ? 'luxe-dialog' : undefined}
        customContentWrapperClass="cart-address-list"
        customContentClass="cart-address-list-dialog"
        fullWidth
        ariaLabel="Select Address"
      >
        <SelectAddressDialog
          locationState={locationState}
          setShowAddressList={setShowAddressList}
          setShowAddressBarDialog={setShowAddressBarDialog}
          setShowFetchingPincodeCard={setShowFetchingPincodeCard}
          currentLocationURL={currentLocationURL}
          currentLocationLuxeURL={currentLocationLuxeURL}
          logoURL={logoURL}
          allowUserLocation={allowUserLocation}
          luxe={luxe}
          addressListLoader={addressListLoader}
          addressList={{addresses: addresses}}
          fromCart={fromCart}
          changeAddress={handleAddressChange}
          setAddressSelected={setAddressSelected}
          handleAddressUpdate={handleAddressUpdate}
          signInCheck={signInCheck}
          setPincodeCardVisibility={setPincodeCardVisibility}
          setPincodeError={setPincodeError}
          setPincodeErrorMsg={setPincodeErrorMsg}
          setShowAddAddress={setShowAddAddress}
          setConfirmPincodeCardVisibility={setConfirmPincodeCardVisibility}
          setFetchedLocationData={setFetchedLocationData}
          enableDeviceLocation={enableDeviceLocation}
          title={addressSelectTitle}
        />
      </Dialog>

      <Dialog
        showDialog={showAddAddress}
        type="drawer"
        onCancel={() => {
          setShowAddAddress(false);
        }}
        customClass={luxe ? 'luxe-dialog' : undefined}
        customContentWrapperClass="cart-address-list"
        customContentClass="cart-address-list-dialog"
        fullWidth={true}
        ariaLabel="Add Address"
      >
        <div className={cx('add-dialog-container')} id="addAddressDialog">
          <AddAddress
            addrFormType="Add"
            device="mobile"
            closeAddAddressMsite={() => {
              setShowAddAddress(false);
              setShowAddressList(true);
            }}
            closeAllAddressMsite={() => {
              setShowAddAddress(false);
              setShowAddressList(false);
              setShowAddressBarDialog?.(false);
            }}
            isCartFlow
            showAddAddress={showAddAddress}
            addressSelected={addressSelected}
            fromCart={fromCart}
            updateAddressOnCart={handleAddressChange}
            handleAddressUpdate={handleAddressUpdate}
            enablePriorityDeliveryPhase2={enablePriorityDeliveryPhase2}
          />
        </div>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  const { request = {}, miscellaneous= {}, product={} } = state;
  const { userAddress: userAddressState={} } = miscellaneous;
  const enablePriorityDeliveryPhase2 = getPriorityDeliveryPhase2Flag(state?.flags);
  const enableRushDelivery = getRushDeliveryFlag(state);
  const isPLAEnabled = getAmplitudeExperimentVariant('enable-pla-on-plp-osmos', state);
  const plaAdsEliminationDisabled = getAmplitudeExperimentVariant('disable-pla-elimination-plp', state);
  const isPlpBannerOsmosEnabled  = getAmplitudeExperimentVariant('enable-plp-banners-plp-osmos', state);
  const osmosPlpBannerSlotsOrder = getAmplitudeVariantPayload('osmosPlpBannerSlots', state, {});
  const enableAdsOnPlpFlag = getEnableAdsOnPlp(state);
  const enableAdsOnSlpFlag = getEnableAdsOnSlp(state);
  const trendBasedDiscoveryFlag = getTrendBasedDiscoveryFlag(state, 'plp');
  const trendBasedDiscoveryConfig = getTrendBasedDiscoveryConfig(state);
  const cartDeliveryAddress = getDeliveryAddress(state);

  return {
    request,
    currentStore: getCurrentStore(state),
    addressBook: state?.addressBook || {},
    enablePriorityDeliveryPhase2,
    userAddressState,
    enableRushDelivery,
    product,
    isPLAEnabled,
    plaAdsEliminationDisabled,
    isPlpBannerOsmosEnabled,
    osmosPlpBannerSlotsOrder,
    enableAdsOnPlpFlag,
    enableAdsOnSlpFlag, 
    trendBasedDiscoveryFlag,
    trendBasedDiscoveryConfig,
    cartDeliveryAddress
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    showLoader: (name: any, config: any) => {
      dispatch(showLoader(name, config));
    },
    getAddressList: (requestObj: {}, cb: null) => dispatch(getAddressData(requestObj, cb)),
    getDefaultAddress: (customerId: '', cb: null, fetchDefaultAddress: false) =>
      dispatch(getLocaleData(customerId, cb, fetchDefaultAddress)),
    changeAddress: (addObj: {}) => dispatch(changeAddressSelectionOnCart(addObj)),
    getlocationFromPostalCode: (
      postalCodeObj: {},
      pincodeCheck: (response: any) => void,
      validatePostalCode: boolean
    ) => {
      dispatch(postalCodeFetch(postalCodeObj, pincodeCheck, validatePostalCode));
    },
    allowUserLocation: (cb = {}) => dispatch(userAllowedLocationForRuntimeLocale({}, cb)),
    fetchPostalCodeDetails: (pincode: any, cb: () => void) =>
      dispatch(fetchPostalCodeDetails(pincode, cb)),
    updateBannerState: (locationObj: {}) => dispatch(updateBannerState(locationObj)),
    updateUserAddressAction: (data: {}) => dispatch(updateUserAddress(data)),
    fetchFecetsFromPincode: (params: { request: any; isRequestFromPlpOnLanding?: any }) =>
      dispatch(
        fetchProducts({
          request: params.request,
          isRequestOrginIsBrowser: true,
          isRequestFromPlpOnLanding: params.isRequestFromPlpOnLanding,
          enableClusterFeatureflag: false,
          cluster: '',
          plpAds: {},
          slpAds: {},
          isPLAEnabled: params.isPLAEnabled,
          plaAdsEliminationDisabledFlag: params.plaAdsEliminationDisabledFlag,
          plpBannerAdsEnabled: params.plpBannerAdsEnabled,
          osmosPlpBannerSlotsOrder: params.osmosPlpBannerSlotsOrder,
          zone: params.zone,
          state: params.state, 
          city: params.city, 
          userRestriction: params.userRestriction,
          userState: params.userState,
          enableAdsOnPlpFlag: params.enableAdsOnPlpFlag,
          enableAdsOnSlpFlag: params.enableAdsOnSlpFlag,
          customerUID: params.customerUID,
          segmentAnonymousId: params.segmentAnonymousId,
          isTrendBasedDiscoveryFlag: params?.isTrendBasedDiscoveryFlag || false,
          trendBasedDiscoveryFlag: params?.trendBasedDiscoveryFlag || {}
        })
      ),
      setSelectedBillingAddress: (address) => dispatch(setSelectedBillingAddress(address)),
      setErrorObject: (data) => dispatch(setErrorObject(data)),
      getChechRushDeliveryAvailability: (pincode: any, latlong: any, optionCode:any, customerUuid:any, isServer:boolean) =>
            dispatch(rushPDPDeliveryTypeAPICall(pincode, latlong, optionCode, customerUuid, isServer)),
      chechRushAvailability: (pincode: any, latlong: any) =>
            dispatch(chechRushAvailabilityAction(pincode, latlong))

  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(AddressBarWrapper);
